import { render, staticRenderFns } from "./wtr-storage-indicator.vue?vue&type=template&id=7c971fa6&scoped=true&"
import script from "./wtr-storage-indicator.vue?vue&type=script&lang=js&"
export * from "./wtr-storage-indicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c971fa6",
  null
  
)

export default component.exports